export const PMS_DEVICES_ACTION_TYPES = {
    PMS_DEVICES_SHOW: "PMS_DEVICES_SHOW",
}